/**
 * 입고 스캔 결과를 소리로 알린다. 상자를 든 채로는 화면의 작은 글씨를 읽지 못한다 —
 * 성공은 짧고 높게, 실패는 길고 낮게.
 *
 * 소리를 못 내는 기기·설정이어도 화면 배너는 그대로 남으므로 조용히 넘어간다.
 */
export function beep(ok: boolean): void {
  try {
    const Ctor =
      window.AudioContext ??
      (window as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
    if (!Ctor) return

    const context = new Ctor()
    const oscillator = context.createOscillator()
    const gain = context.createGain()
    oscillator.frequency.value = ok ? 880 : 220
    gain.gain.value = 0.08
    oscillator.connect(gain).connect(context.destination)
    oscillator.start()
    oscillator.stop(context.currentTime + (ok ? 0.1 : 0.3))
    oscillator.onended = () => void context.close()
  } catch {
    // 소리를 못 내도 화면 배너는 남는다.
  }
}
